/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HillsIndexRouteImport } from './routes/hills.index'
import { Route as ArchiveIndexRouteImport } from './routes/archive.index'
import { Route as HillsHillIdRouteImport } from './routes/hills.$hillId'
import { Route as ArchiveHillIdRouteImport } from './routes/archive.$hillId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HillsIndexRoute = HillsIndexRouteImport.update({
  id: '/hills/',
  path: '/hills/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveIndexRoute = ArchiveIndexRouteImport.update({
  id: '/archive/',
  path: '/archive/',
  getParentRoute: () => rootRouteImport,
} as any)
const HillsHillIdRoute = HillsHillIdRouteImport.update({
  id: '/hills/$hillId',
  path: '/hills/$hillId',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveHillIdRoute = ArchiveHillIdRouteImport.update({
  id: '/archive/$hillId',
  path: '/archive/$hillId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/archive/$hillId': typeof ArchiveHillIdRoute
  '/hills/$hillId': typeof HillsHillIdRoute
  '/archive/': typeof ArchiveIndexRoute
  '/hills/': typeof HillsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/archive/$hillId': typeof ArchiveHillIdRoute
  '/hills/$hillId': typeof HillsHillIdRoute
  '/archive': typeof ArchiveIndexRoute
  '/hills': typeof HillsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/archive/$hillId': typeof ArchiveHillIdRoute
  '/hills/$hillId': typeof HillsHillIdRoute
  '/archive/': typeof ArchiveIndexRoute
  '/hills/': typeof HillsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/archive/$hillId'
    | '/hills/$hillId'
    | '/archive/'
    | '/hills/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/archive/$hillId'
    | '/hills/$hillId'
    | '/archive'
    | '/hills'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/archive/$hillId'
    | '/hills/$hillId'
    | '/archive/'
    | '/hills/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ArchiveHillIdRoute: typeof ArchiveHillIdRoute
  HillsHillIdRoute: typeof HillsHillIdRoute
  ArchiveIndexRoute: typeof ArchiveIndexRoute
  HillsIndexRoute: typeof HillsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hills/': {
      id: '/hills/'
      path: '/hills'
      fullPath: '/hills/'
      preLoaderRoute: typeof HillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive/': {
      id: '/archive/'
      path: '/archive'
      fullPath: '/archive/'
      preLoaderRoute: typeof ArchiveIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hills/$hillId': {
      id: '/hills/$hillId'
      path: '/hills/$hillId'
      fullPath: '/hills/$hillId'
      preLoaderRoute: typeof HillsHillIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive/$hillId': {
      id: '/archive/$hillId'
      path: '/archive/$hillId'
      fullPath: '/archive/$hillId'
      preLoaderRoute: typeof ArchiveHillIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ArchiveHillIdRoute: ArchiveHillIdRoute,
  HillsHillIdRoute: HillsHillIdRoute,
  ArchiveIndexRoute: ArchiveIndexRoute,
  HillsIndexRoute: HillsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
